<template>
  <div id="app">
    <iheader v-if="showH"></iheader>
    <router-view :key="$route.fullPath"></router-view>
    <ifooter v-if="showF"></ifooter>
  </div>
</template>

<script>
import iheader from "./views/header";
import ifooter from "./views/footer";
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.commit("initUser");
    },
    ...mapState({
      showF: (state) => state.showF,
      showH: (state) => state.showH,
    }),
  },
  components: {
    iheader,
    ifooter,
  },
  created() {
    this.$store.commit("initUser");
    this.$store.commit('socket/warehouseStockUpdateMsgLS_TO_ST')
    this.$store.dispatch('setTimer')
  },
};
</script>

<style lang="scss"></style>
